import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Bell } from 'lucide-react';

export interface ChannelItem {
  key: string;
  label: string;
  description: string;
  enabled: boolean;
}

interface NotificationChannelsProps {
  items: ChannelItem[];
  onToggle: (key: string) => void;
  title: string;
  description?: string;
}

const NotificationChannels = ({
  items,
  onToggle,
  title,
  description,
}: NotificationChannelsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
          <Bell className="h-5 w-5 flex-shrink-0" />
          <span>{title}</span>
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-4">
          {items.map(item => (
            <div key={item.key} className="flex items-center justify-between">
              <div className="space-y-0.5 min-w-0 flex-1 mr-2">
                <Label className="text-sm">{item.label}</Label>
                <p className="text-xs sm:text-sm text-muted-foreground">
                  {item.description}
                </p>
              </div>
              <Button
                variant={item.enabled ? 'default' : 'outline'}
                size="sm"
                onClick={() => onToggle(item.key)}
              >
                {item.enabled ? 'Enabled' : 'Disabled'}
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default NotificationChannels;
